// Lista do sino (components/NotificationsPanel.vue): separa lidas de não lidas e
// agrupa por dia ("Hoje", "Ontem", "19 de outubro"). Funções puras — a data de
// referência entra por parâmetro para o teste não depender do relógio.

// `createAt` vem do EadApi sem fuso (hora local do servidor, Brasília); o
// `new Date` o lê como hora local do aparelho, que para o aluno é a mesma.
export function notificationDate (notification) {
  const raw = notification && notification.createAt;
  if (!raw) return null;
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function isUnread (notification) {
  return Boolean(notification) && notification.readOn == null;
}

export function splitByRead (notifications) {
  const unread = [];
  const read = [];
  (notifications || []).forEach(n => {
    if (!n) return;
    (isUnread(n) ? unread : read).push(n);
  });
  return { unread, read };
}

function dayKey (date) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function dayLabel (date, now = new Date()) {
  if (!date) return 'Sem data';
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const day = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.round((today - day) / 86400000);
  if (diffDays === 0) return 'Hoje';
  if (diffDays === 1) return 'Ontem';
  const options = { day: 'numeric', month: 'long' };
  if (date.getFullYear() !== now.getFullYear()) options.year = 'numeric';
  return date.toLocaleDateString('pt-BR', options);
}

// Mantém a ordem de entrada (o EadApi já devolve da mais nova para a mais
// antiga); notificação sem data válida vai para um grupo "Sem data" no fim.
export function groupByDay (notifications, now = new Date()) {
  const groups = [];
  const byKey = new Map();
  let undated = null;
  (notifications || []).forEach(n => {
    if (!n) return;
    const date = notificationDate(n);
    if (!date) {
      if (!undated) undated = { key: 'sem-data', label: dayLabel(null, now), items: [] };
      undated.items.push(n);
      return;
    }
    const key = dayKey(date);
    let group = byKey.get(key);
    if (!group) {
      group = { key, label: dayLabel(date, now), items: [] };
      byKey.set(key, group);
      groups.push(group);
    }
    group.items.push(n);
  });
  if (undated) groups.push(undated);
  return groups;
}

export function timeLabel (notification) {
  const date = notificationDate(notification);
  return date ? date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '';
}
